import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl, intlShape } from 'react-intl';
import TeacherView from '../../components/teacher-view/index';
import { getProductTeachers } from '../teacher-roll/actions';
import {
    getTeacherAuthTokenRequest
} from './actions';
import { DEFAULT_TEACHER_ID, teacherUserTypeId } from '../../constants';
import messages from './messages';
import { getTeacherAuthToken } from '../../api';

class TeacherViewContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTeacherId: DEFAULT_TEACHER_ID,
            teachers: [],
            redirectUri: undefined,
            isFetchingData: false
        };
    }

    componentDidMount() {
        const { teachers, selectedProduct } = this.props;

        if (!teachers.length) {
            this.props.getProductTeachers(selectedProduct.id);
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            teachers: this.updateTeacherTitle(nextProps.teachers)
        });
        this.setState({
            redirectUri: nextProps.redirectUri
        });
    }

    updateTeacherTitle = (teachers) => {
        const updatedTeachers = teachers.map(teacher => ({
            ...teacher,
            name: teacher.isCurrentUser ? `${teacher.name} (${this.props.intl.formatMessage(messages.teacherViewYou)})` : teacher.name
        }));

        return updatedTeachers;
    }

    handleOnLaunch = async () => {
        /* Previous implementation url
        const portalUrl = `${config.portalUrl}${authToken}&tstamp=${tStamp}&lang=${getLocale()}&productId=${selectedProduct.id}&JWT=${teacherJWTToken}`;
        } */
        // TODO: Revisit to determine if we need the extra query params for new redirection rules
        // New Teacher impersonation involves redirecting to the URL specified in the login response object
        // 3Essential / 3P Roster teachers will be redirected to the 3E TUI, the others will be redirected to MX portal
        const { teachers, selectedTeacherId } = this.state;

        if (selectedTeacherId !== DEFAULT_TEACHER_ID) {
            this.setState({ isFetchingData: true });
            const response = await getTeacherAuthToken(teacherUserTypeId, Number(selectedTeacherId));
            const redirectUri = response.data.redirectUri;

            if (redirectUri) {
                this.setState({ isFetchingData: false });

                const isCurrentUser = teachers.filter(teacher => teacher.id.toString() === this.state.selectedTeacherId)[0].isCurrentUser;
                if (isCurrentUser) {
                    window.parent.location.href = redirectUri;
                    return;
                }

                const tStamp = new Date().getTime();
                const separator = redirectUri.includes('?') ? '&' : '?';
                const timestampedRedirectUri = `${redirectUri}${separator}tstamp=${tStamp}`;
                window.open(timestampedRedirectUri, '_blank');
            }
        }
    }

    onTeacherSelectionChange = (name, value) => {
        this.setState({ selectedTeacherId: value });
    }

    render() {
        return (<TeacherView
            handleOnLaunch={this.handleOnLaunch}
            onTeacherSelection={this.onTeacherSelectionChange}
            selectedTeacherId={this.state.selectedTeacherId}
            {...this.props}
            isFetchingData={this.state.isFetchingData}
            teachers={this.state.teachers}
        />);
    }
}

// TODO: Cleanup JWTToken - we don't seem to use it anywhere. With 3Essentials / 3P Roster, it is obsolete.
TeacherViewContainer.propTypes = {
    selectedProduct: PropTypes.object,
    teachers: PropTypes.array,
    getProductTeachers: PropTypes.func,
    isTeachersLoaded: PropTypes.bool,
    getTeacherAuthTokenRequest: PropTypes.func,
    authToken: PropTypes.string,
    teacherJWTToken: PropTypes.string,
    redirectUri: PropTypes.string,
    isGettingToken: PropTypes.bool,
    intl: intlShape.isRequired
};

const mapStateToProps = state => ({
    selectedProduct: state.product,
    teachers: state.teacherView.teachers,
    isTeachersLoaded: state.teacherView.isTeachersLoaded,
    authToken: state.teacherView.authToken,
    teacherJWTToken: state.teacherView.teacherJWTToken,
    redirectUri: state.teacherView.redirectUri,
    isGettingToken: state.teacherView.isGettingToken
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getProductTeachers,
        getTeacherAuthTokenRequest
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TeacherViewContainer));



// WEBPACK FOOTER //
// ./app/containers/teacher-view/index.js